(() => {
  if (window.__bpcProductPriceLayoutLoaded) return;
  window.__bpcProductPriceLayoutLoaded = true;

  let queued = false;
  let rendering = false;

  const getCents = (item) => {
    const stored = Number(item.dataset.bpcProductUsdCents);
    if (Number.isFinite(stored) && stored >= 0) return Math.round(stored);

    const raw = item.dataset.bpcUsdCents;
    if (raw == null || String(raw).trim() === '') return null;

    const source = Number(raw);
    if (!Number.isFinite(source) || source < 0) return null;

    const cents = Math.round(source);
    item.dataset.bpcProductUsdCents = String(cents);
    return cents;
  };

  const restoreUsd = (item, engine) => {
    const cents = getCents(item);
    if (!Number.isFinite(cents)) return null;

    const from = item.dataset.bpcPriceFrom === 'true';
    const text = `${from ? 'From ' : ''}${engine.formatUsd(cents / 100)}`;

    item.removeAttribute('data-bpc-usd-cents');
    item.removeAttribute('data-bpc-fx-key');
    if (item.textContent.trim() !== text) item.textContent = text;

    return cents;
  };

  const getMetaBlock = (root) => {
    const parent = root.parentElement;
    if (!parent) return null;

    parent.querySelectorAll(':scope > .bpc-product-price-meta').forEach((node) => {
      if (node.previousElementSibling !== root) node.remove();
    });

    let meta = root.nextElementSibling;
    if (!meta || !meta.classList.contains('bpc-product-price-meta')) {
      meta = document.createElement('div');
      meta.className = 'bpc-product-price-meta bpc-product-price-meta--stable';
      meta.setAttribute('data-bpc-product-price-meta', '');
      meta.setAttribute('data-nosnippet', '');
      root.insertAdjacentElement('afterend', meta);
    }

    return meta;
  };

  const renderProductPrice = (root, engine) => {
    root.querySelectorAll('.price-item[data-bpc-usd-cents],.price-item[data-bpc-product-usd-cents]').forEach((item) => {
      restoreUsd(item, engine);
    });

    root.querySelectorAll(
      '.bpc-product-price-approx-label,.bpc-product-checkout-usd,:scope > .bpc-product-local-estimate,:scope > .bpc-product-currency-note'
    ).forEach((node) => node.remove());

    const visible = root.classList.contains('price--on-sale')
      ? root.querySelector('.price__sale .price-item--sale')
      : root.querySelector('.price__regular .price-item--regular');

    if (!visible) return;

    const cents = Number(visible.dataset.bpcProductUsdCents);
    if (!Number.isFinite(cents) || cents < 0) return;

    const localValue = engine.toLocal(cents / 100);
    if (!Number.isFinite(localValue) || localValue <= 0) return;

    const from = visible.dataset.bpcPriceFrom === 'true';
    const localText = `(approx. ${from ? 'from ' : ''}${engine.formatLocal(localValue)})`;
    const key = `${cents}:${engine.rate}:${engine.buffer}:${engine.currency}:${from ? 'from' : 'fixed'}`;
    const meta = getMetaBlock(root);
    if (!meta) return;

    let local = meta.querySelector(':scope > .bpc-product-local-estimate');
    if (!local) {
      local = document.createElement('span');
      local.className = 'bpc-product-local-estimate';
      meta.appendChild(local);
    }

    if (local.dataset.bpcProductFxKey !== key || local.textContent !== localText) {
      local.textContent = localText;
      local.dataset.bpcProductFxKey = key;
    }
    local.removeAttribute('data-bpc-price-pending');
    local.removeAttribute('aria-hidden');

    let note = meta.querySelector(':scope > .bpc-product-currency-note');
    if (!note) {
      note = document.createElement('span');
      note.className = 'bpc-product-currency-note';
      meta.appendChild(note);
    }
    note.textContent = 'Checkout is charged in USD.';

    root.setAttribute(
      'aria-label',
      `${engine.formatUsd(cents / 100)}; approximately ${engine.formatLocal(localValue)} in local currency`
    );
  };

  const render = () => {
    queued = false;
    if (rendering) return;

    const engine = window.BpcCurrency;
    if (!engine || engine.currency === 'USD') return;

    rendering = true;
    document
      .querySelectorAll('.product__info-container [id^="price-"] .price--large,.product__info-container .price--large')
      .forEach((root) => renderProductPrice(root, engine));
    rendering = false;
  };

  const schedule = () => {
    if (queued || rendering) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(render));
  };

  document.addEventListener('bpc:currency-ready', schedule);
  document.addEventListener('shopify:section:load', schedule);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  if (window.BpcCurrency) schedule();
})();

/* BPC-AVAILABLE-OPTION-FILTER-059
 * Dropdown-only storefront guard. Keeps Shopify catalog variants unchanged while
 * removing option values that cannot form an available variant with selections above them.
 */
(() => {
  if (window.__bpcAvailableOptionFilter059Loaded) return;
  window.__bpcAvailableOptionFilter059Loaded = true;

  const PLACEHOLDER = 'placeholder';

  const getOptions = (variant) => {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
  };

  const isCustomerVariant = (variant) => {
    if (!variant || variant.available !== true) return false;
    return getOptions(variant).every(
      (value) => String(value).trim().toLowerCase() !== PLACEHOLDER
    );
  };

  const getVariantData = (picker) => {
    if (Array.isArray(picker.__bpcAvailableVariantData059)) {
      return picker.__bpcAvailableVariantData059;
    }

    const source = picker.querySelector('script[type="application/json"]');
    if (!source) return [];

    try {
      const variants = JSON.parse(source.textContent || '[]');
      picker.__bpcAvailableVariantData059 = Array.isArray(variants) ? variants : [];
    } catch (error) {
      console.error('BPC option filter: variant data could not be parsed.', error);
      picker.__bpcAvailableVariantData059 = [];
    }

    return picker.__bpcAvailableVariantData059;
  };

  const normaliseOption = (option) => {
    option.disabled = false;
    option.hidden = false;
    option.removeAttribute('disabled');
    option.removeAttribute('hidden');
    option.removeAttribute('selected');
    option.textContent = option.value;
    return option;
  };

  const cacheOptionTemplates = (picker) => {
    if (picker.__bpcSelectOptionTemplates059) return;

    picker.__bpcSelectOptionTemplates059 = Array.from(picker.querySelectorAll('select')).map(
      (select) => Array.from(select.options, (option) => normaliseOption(option.cloneNode(true)))
    );
  };

  const rebuildDependentSelects = (picker, startIndex = 1) => {
    const selects = Array.from(picker.querySelectorAll('select'));
    if (selects.length < 2) return false;

    cacheOptionTemplates(picker);
    const variants = getVariantData(picker);
    if (!variants.length) return false;

    let selectionChanged = false;
    const firstIndex = Math.max(1, startIndex);

    for (let index = firstIndex; index < selects.length; index += 1) {
      const select = selects[index];
      const previousValues = selects.slice(0, index).map((item) => item.value);
      const allowedValues = new Set();

      variants.forEach((variant) => {
        if (!isCustomerVariant(variant)) return;

        const options = getOptions(variant);
        if (options.length <= index) return;

        const matchesPrevious = previousValues.every(
          (value, previousIndex) => options[previousIndex] === value
        );

        if (matchesPrevious) allowedValues.add(options[index]);
      });

      const previousValue = select.value;
      const templates = picker.__bpcSelectOptionTemplates059[index] || [];
      const availableOptions = templates
        .filter((option) => allowedValues.has(option.value))
        .map((option) => normaliseOption(option.cloneNode(true)));

      select.replaceChildren(...availableOptions);

      if (!availableOptions.length) {
        select.disabled = true;
        select.setAttribute('aria-disabled', 'true');
        if (previousValue !== '') selectionChanged = true;
        continue;
      }

      select.disabled = false;
      select.removeAttribute('aria-disabled');

      if (allowedValues.has(previousValue)) {
        select.value = previousValue;
      } else {
        select.value = availableOptions[0].value;
        selectionChanged = true;
      }
    }

    return selectionChanged;
  };

  const initialisePicker = (picker) => {
    if (!(picker instanceof HTMLElement) || picker.dataset.bpcAvailableOptionFilter059 === 'true') return;

    const selects = Array.from(picker.querySelectorAll('select'));
    if (selects.length < 2) return;

    picker.dataset.bpcAvailableOptionFilter059 = 'true';
    cacheOptionTemplates(picker);

    picker.addEventListener(
      'change',
      (event) => {
        if (!(event.target instanceof HTMLSelectElement)) return;

        const currentSelects = Array.from(picker.querySelectorAll('select'));
        const changedIndex = currentSelects.indexOf(event.target);
        if (changedIndex < 0 || changedIndex >= currentSelects.length - 1) return;

        rebuildDependentSelects(picker, changedIndex + 1);
      },
      true
    );

    const initialSelectionChanged = rebuildDependentSelects(picker, 1);
    if (!initialSelectionChanged) return;

    customElements.whenDefined('variant-selects').then(() => {
      if (!picker.isConnected || typeof picker.onVariantChange !== 'function') return;
      picker.onVariantChange();
    });
  };

  const scan = (root) => {
    if (!root) return;
    if (root.matches && root.matches('variant-selects')) initialisePicker(root);
    if (root.querySelectorAll) root.querySelectorAll('variant-selects').forEach(initialisePicker);
  };

  const boot = () => {
    scan(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach(scan));
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
